import { Node as DeliveryNode } from 'contensis-delivery-api';
import { Node } from 'contensis-management-api';
import { MigrateStatus } from './Migration';

export type MigrateNode = {
  contentTypeId?: string;
  diff?: string;
  displayName: string;
  entryId?: string;
  existing?: DeliveryNode;
  id: string;
  node: Node | DeliveryNode;
  parentId?: string;
  path: string;
  originalId: string;
  status: MigrateStatus;
  error?: MappedError;
};

export type MigrateNodesTree = Omit<DeliveryNode, 'children' | 'version'> & {
  children: MigrateNodesTree[];
  diff?: string;
  displayName: string;
  originalId: string;
  originalParentId?: string;
  status: MigrateStatus;
  error?: MappedError;
};

export type BuildNodeOptions = {
  onError: (migrateNode: MigrateNode) => void;
};

export type MigrateNodeModel = {
  contentTypeId?: string;
  displayName: string;
  entryId?: string;
  existing?: DeliveryNode;
  id: string;
  node: Node | DeliveryNode;
  originalId: string;
  parentId?: string;
  path: string;
  sourceNode: DeliveryNode;
  status: MigrateStatus;
};
